import { UrlMatchResult, UrlSegment } from '@angular/router';

/**
 * Matches pattern `** / slug-:productCode`
 * @param segments
 */
export function customProductDetailsUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length > 1 && segments[0].path === 'product') {
    const uriNameSegment = segments[1];
    const productCode = uriNameSegment.path.replace(/.*-(r?\d+)$/gm, '$1');

    return {
      consumed: [...segments],
      posParams: { productCode: new UrlSegment(productCode, {}) },
    };
  }

  return null;
}
